import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * POM-6534 — the Lot section of Change NDC & Lot: its heading row, and whatever the dialog puts
 * under it (the stock lot table, or the hand-recorded panel). `headerAction` sits at the right of
 * the heading row.
 */
const ChangeNdcLotLotSection = ({ caption, headerAction, children }) => (
  <Box>
    <Stack direction='row' alignItems='center' sx={{ gap: 1, mb: 1, minHeight: 32 }}>
      <Typography variant='subtitle1' component='h3' sx={{ fontWeight: 700, lineHeight: 1.3 }}>
        Lot
      </Typography>
      {caption && (
        <Typography variant='body2' sx={{ color: 'grey.800' }}>
          {caption}
        </Typography>
      )}
      {headerAction && <Box sx={{ ml: 'auto' }}>{headerAction}</Box>}
    </Stack>
    {children}
  </Box>
);

ChangeNdcLotLotSection.propTypes = {
  caption: PropTypes.string,
  headerAction: PropTypes.node,
  children: PropTypes.node,
};

ChangeNdcLotLotSection.defaultProps = {
  caption: '',
  headerAction: null,
  children: null,
};

export default ChangeNdcLotLotSection;
